import { Task } from "~/types/task";
import { baseService } from "../base";
import { PaginationResponse } from "../type";
import { CreateNoteParams, GetTaskParams } from "./task.types";

export const taskService = {
  getTasks: async (params: GetTaskParams) => {
    const { data } = await baseService.get<PaginationResponse<Task>>("/task", {
      params,
    });
    return data;
  },
  getTask: async (taskId: string) => {
    const { data } = await baseService.get<Task>(`/task/${taskId}`);
    return data;
  },
  getMostUrgentTasks: async () => {
    const { data } = await baseService.get<Task[]>(
      `/task/urgent`
    );
    return data;
  },
  createTask: async (payload: FormData) => {
    const { data } = await baseService.post("/task", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  updateTask: async ({
    taskId,
    payload,
  }: {
    taskId: string;
    payload: FormData;
  }) => {
    const { data } = await baseService.patch(`/task/${taskId}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  createNote: async (body: CreateNoteParams) => {
    const { data } = await baseService.post("/notes", body);
    return data;
  },
  deleteTask: async (taskId: string) => {
    const { data } = await baseService.delete(`/task/${taskId}`);
    return data;
  },
};
